module.exports = __webpack_public_path__ + "static/media/2.ded95918.svg";